import msgs from './config/msgs'

//var url = 'https://5703eca29bbecf980cb9647ab2f1712doauth.ibroadlink.com/';
//var url = "https://140593719a46aba20ae7a5c43ca73d97oauth.ibroadlink.com/";
//var url = "https://fc1c75057a24a6a2b911e082dbd9f69coauth.ibroadlink.com/";

var url = 'https://' + window.location.host + '/';

var facebookRedirect = url + 'login';

//facebook的app id
var APPID = '1771203789852650';

//关于lid的配置
var configPlatformObj = {
  alexa: {
    us: "fc1c75057a24a6a2b911e082dbd9f69c",
    eu: "7efc94aead1de486871af24f8109496f",
    zh: "140593719a46aba20ae7a5c43ca73d97",
	id: "4f995e5159c48569a56f5a53c41d0a3b"
  },
  google: {
    us: "5703eca29bbecf980cb9647ab2f1712d",
    eu: "50f581a4070d2ebc30f90720f1b9212a",
    zh: "140593719a46aba20ae7a5c43ca73d97",
	id: "9d5aae85908d4f40e518076ace92f83e"
  },
  ifttt: {
    us: "bfae6a674aab43a5a0e98e9febc487b3",
    eu: "d7f25c1b248ebbd964d54159cb0ab17b",
    zh: "bfae6a674aab43a5a0e98e9febc487b3", //临时
	id: "4f995e5159c48569a56f5a53c41d0a3b"
  }
};

/** 
 * 关于client_id和redirect_uri的配置
 * add by yangzhiyan
*/
var configUrl = {
	alexa: {
		us: {
			client_id: "5ea670ed7cc543133fe3f8e9324e8ba2",
			url: "https://pitangui.amazon.com/api/skill/link/M1TJ2VD8XAW3VZ"
		},
	  	eu: {
			client_id: "ea29a2c9060fa0aa87ab2d617cbdd54c",
			url: "https://pitangui.amazon.com/api/skill/link/M1TJ2VD8XAW3VZ"
		},
		id : {
			// client_id: "id",
			url: "https://pitangui.amazon.com/api/skill/link/M1TJ2VD8XAW3VZ"
		}
	},
	google: {
		us: {
			client_id: "80ac184eb7a704bf663f369d3500542e",
			url: "https://oauth-redirect.googleusercontent.com/r/contros-for-usa"
		},
	  	eu: {
			client_id: "84dcecb35b9123a7052e1c012937b023",
			url: "https://oauth-redirect.googleusercontent.com/r/contros-for-usa"
			//url: "https://oauth-redirect.googleusercontent.com/r/contros-for-eu"
		},
		id : {
			// client_id: "id",
			url: "https://oauth-redirect.googleusercontent.com/r/contros-for-usa"
		}
	}
}

//设置默认的语言 默认英语
var basicLan = "en";

//国家对应的语言配置
var configObj = {
	"zh": "zh",
	"en": "en",
	"eu": "eu",
	"de": "de",
	"ru": "ru",
	"fr": "fr",
	"es": "es",
	"ja": "ja",
	"it": "it",
	"pt": "pt",
	"hi": "hi",
	"pl": "pl",
	"da": "da",
	"sv": "sv"
};

//判断是否有参数
var hrefStr = window.location.href;
console.log("hrefstr",hrefStr)
if(hrefStr.indexOf("lang=") >= 0) {
	var index = hrefStr.indexOf("lang=");
	basicLan = hrefStr.substr(index + 5, 2);
	console.log("lang",index);
}

// 处理页面显示语言
var dealLan = function(content, languaue) {
	//只有隐私政策才有的判断
	return content[languaue] || content[basicLan];
}

// 处理消息
var dealMsg = function(data) {
	var msgTxt = dealLan(msgs);
	for (var i = msgTxt.length - 1; i >= 0; i--) {
		if(msgTxt[i].key == data) {

			if(msgTxt[i].text) {
				return {
					value: msgTxt[i].value,
					text: msgTxt[i].text
				}
			} else {
				return msgTxt[i].value;
			}
		}
	}
};

//取得完整的url 这里暂时排除nginx配置，因为有可能url配置的并不是dist层
var getPathName = function() {
	var pathName = window.location.pathname;
	pathName = pathName.replace("/confirm", "");
	pathName = pathName.replace("/login", "");
	pathName = pathName.replace("/privacy", "");
	pathName = pathName.replace("/serviceTerm", "");
	pathName = pathName.replace("/faq", "");
	pathName = pathName.replace("/selcountry", "");
	if(pathName[pathName.length - 1] == "/") {
		pathName = pathName.substr(0, pathName.length - 1);
	}
	return pathName;
};

//获取URL参数
var getURLParams = function(originStr) {
	var searchStr = originStr || window.location.search || "";
	if(!searchStr) {
		return false;
	}
	//数据object
	var paramObj = {};
	//去除？
	searchStr = searchStr.substring(1);

	//根据数据筛选
	var array = searchStr.split("&");
	for (var i = 0; i < array.length; i++) {
		var temp = array[i];
		//这里多了一步，防止有多个 =
		var tempArray = temp.replace("=", "&").split("&");
		for (var j = 0; j < tempArray.length; j++) {
			var keyStr = tempArray[0], valueStr = tempArray[1];
			if("redirect_uri" === keyStr) {
				//判断 redirect_uri的内容有没有被编译
				if(valueStr.indexOf("://") >= 0) {
					valueStr = encodeURIComponent(valueStr);
				} else if(valueStr.indexOf("%3A%2F%2F") >= 0) {
					valueStr = decodeURIComponent(valueStr);
				}
			}
			paramObj[keyStr] = valueStr;
		}
	}
	return paramObj;
};

//判断是否存在参数
var getParamStr = function(str, originStr) {
	//数据object
	var paramObj = getURLParams(originStr) || {};

	return paramObj[str] || false;
};

export {
	url,
	facebookRedirect,
	APPID,
	dealLan,
	dealMsg,
	configObj,
	getPathName,

	getURLParams,
	getParamStr,
	configPlatformObj,
	configUrl
}


//////////////////
// WEBPACK FOOTER
// ./static/js/public.js
// module id = nwBL
// module chunks = 7